import { render, staticRenderFns } from "./cash-collection-by-cashier.vue?vue&type=template&id=fb12083e&"
import script from "./cash-collection-by-cashier.vue?vue&type=script&lang=js&"
export * from "./cash-collection-by-cashier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports